import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Approuter from "./routes/router";
import BodyBackgroundSync from "./components/BodyBackgroundSync";
import ThnBackground from "./components/thn/ThnBackground";

function App() {
  return (
    <BrowserRouter>
      <BodyBackgroundSync />
      <ThnBackground />
      <Approuter />
    </BrowserRouter>
  );
}

export default App;
